import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useRootContext } from 'app/services/RootProvider/RootProvider'
import { useUserContext } from 'app/services/UserProvider/UserProvider'

const useRenderNavLinks = (links, Component, handleClickLink) => {
  const { account } = useUserContext()
  const { route } = useRootContext()

  const output = useMemo(() => {
    if (!links || !links.length) {
      return null
    }

    return (
      <>
        {links.map((link, i) => {
          if (link.prerequisite) {
            if (link.prerequisite === 'has_account' && !account?.isSignedIn) {
              return null
            }
          }

          if (!link.action || link.action === 'validate') {
            const isActive = !!route?.path?.exec(link.url)

            return (
              <Component
                Tag={Link}
                key={i}
                to={link.url}
                onClick={e => handleClickLink(e, link)}
                isActive={isActive}
              >
                {link.title}
              </Component>
            )
          }

          if (link.action === 'external') {
            return (
              <Component
                Tag="a"
                key={i}
                href={link.url}
                target="_blank"
                onClick={e => handleClickLink(e, link)}
              >
                {link.title}
              </Component>
            )
          }

          return (
            <Component
              Tag="button"
              key={i}
              onClick={e => handleClickLink(e, link)}
              isActive={link.isActive}
            >
              {link.title}
            </Component>
          )
        })}
      </>
    )
  }, [links, account, route])

  return output
}

// export
export default useRenderNavLinks
